import React, {useState, useEffect, useContext} from 'react';
import {Grid, Typography, Checkbox, Snackbar} from '@material-ui/core';
import NumberField from "../../../../FormikUtils/NumberField";
import Loading from "../../../../../Loading";
import {Field, useFormikContext} from "formik";
import {makeStyles} from "@material-ui/core/styles";
import Alert from '@material-ui/lab/Alert';
import PopOverDetails from "../../../../../PopOverInfo";
import CotizarContext from "../../../../../../context/CotizarContext";
import FormikAutocomplete from "../../../../FormikUtils/FormikAutocomplete";
import InputField from "../../../../FormikUtils/InputField";
import {
    IconBike,
    IconCamera,
    IconDeviceLaptop,
    IconDeviceTablet,
    IconScooter,
    IconFirstAidKit,
    IconPlaneDeparture,
    IconPhoneCall
} from "@tabler/icons";


const useStyles = makeStyles((theme) => ({
    noCost: {
        fontFamily: 'EncodeSansBold',
        fontSize: "14px",
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansRegular',
        fontSize: "18px",
        lineHeight: "1"
    },
    tableRowLabel: {
        fontFamily: 'Nunito'
    },
    centerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
    coverageIcon: {
        width: "40px",
        height: "40px",
        strokeWidth: "2px",
    }
}));

export default function CoberturasForm(props) {
    const {
        formField: {
            codigosLocalidad,
            afinidad,
            coberturasAdicionales: {
                sumaAsegurada,
            },
            fechaCotizacion
        },
        cotizacionRetomada
    } = props;

    const {coberturasInfo} = useContext(CotizarContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const [dictCoberturasInfo, setDictCoberturasInfo] = useState(null);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const {localidades, afinidades} = useContext(CotizarContext)
    const numerosCoberturasAdicionales = ["26", "36", "37", "48", "49"];
    const [coberturasState, setCoberturasState] = useState([
        {selected: false, numeroCobertura: "26", sumaAsegurada: 0},
        {selected: false, numeroCobertura: "36", sumaAsegurada: 0},
        {selected: false, numeroCobertura: "37", sumaAsegurada: 0},
        {selected: false, numeroCobertura: "48", sumaAsegurada: 0},
        {selected: false, numeroCobertura: "49", sumaAsegurada: 0},
        {selected: true, numeroCobertura: "44", sumaAsegurada: "Sin Costo"},
        {selected: true, numeroCobertura: "45", sumaAsegurada: "Sin Costo"},
        {selected: true, numeroCobertura: "50", sumaAsegurada: "Sin Costo"},
    ]);

    const iconsDict = {
        "26": <IconCamera className={classes.coverageIcon}/>,
        "36": <IconDeviceLaptop className={classes.coverageIcon}/>,
        "37": <IconDeviceTablet className={classes.coverageIcon}/>,
        "48": <IconBike className={classes.coverageIcon}/>,
        "49": <IconScooter className={classes.coverageIcon}/>,
        "44": <IconPlaneDeparture className={classes.coverageIcon}/>,
        "45": <IconFirstAidKit className={classes.coverageIcon}/>,
        "50": <IconPhoneCall className={classes.coverageIcon}/>,
    }

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    function handleChecked(index) {
        let items = [...coberturasState];
        let item = {...items[index]};
        item.selected = !item.selected;
        items[index] = item;
        setCoberturasState(items);

        // TODO: Remove this fix for existing quotations without coverage '26' in its initialValues
        let itemCobertura26 = coberturasInfo.find(obj => {
            return obj.NumeroCobertura === '26'
        })
        if (values.coberturasAdicionales[index] === undefined)
            values.coberturasAdicionales.push({
                numeroCobertura: '26',
                sumaAsegurada: itemCobertura26.SumaChica,
                selectedCobertura: false
            })

        values.coberturasAdicionales[index].selectedCobertura = item.selected
    }

    function handleValueChange(e, index) {
        let value = e.target.value;
        if (!value.match(/^([0-9]{1,3}.([0-9]{3}.)*[0-9]{3}|[0-9]+)?$/))
            value = 0;
        else if (value === "")
            value = 0;
        else
            value = parseInt(value.toString().replace(/\./g, ""));

        let item = values.coberturasAdicionales[index];

        if (value < dictCoberturasInfo[item.numeroCobertura].sumaMinima) {
            handleOpenAlert(`El valor mínimo para esta cobertura es ${dictCoberturasInfo[item.numeroCobertura].sumaMinima}`);
            value = dictCoberturasInfo[item.numeroCobertura].sumaMinima
        }

        if (value > dictCoberturasInfo[item.numeroCobertura].sumaMaxima) {
            handleOpenAlert(`El valor máximo para esta cobertura es ${dictCoberturasInfo[item.numeroCobertura].sumaMaxima}`);
            value = dictCoberturasInfo[item.numeroCobertura].sumaMaxima
        }

        let coberturasStateData = [...coberturasState];
        coberturasStateData[index].sumaAsegurada = value;
        setCoberturasState(coberturasStateData);

        setFieldValue(`coberturasAdicionales[${index}].${sumaAsegurada.name}`, value)
    }

    useEffect(() => {
        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                sumaChica: item.SumaChica,
                sumaMediana: item.SumaMediana,
                sumaGrande: item.SumaGrande,
                sumaMaxima: item.SumaMaxima,
                sumaMinima: item.SumaMinima,
                descripcion: item.Descripcion,
                descripcionCompleta: item.DescripcionCompleta,
            });

        if (cotizacionRetomada) {

            let dictCoberturas = {};
            values.coberturasAdicionales.map((item) => {
                dictCoberturas[item.numeroCobertura] = {
                    sumaAsegurada: item.sumaAsegurada,
                }
            });

            values.coberturasAdicionales = []

            coberturasState.forEach((cob) => {
                if (numerosCoberturasAdicionales.includes(cob.numeroCobertura)) {
                    values.coberturasAdicionales.push({
                        numeroCobertura: cob.numeroCobertura,
                        sumaAsegurada: cob.sumaAsegurada,
                        selectedCobertura: cob.selected,
                    })
                }
            })

            let coberturasStateData = [...coberturasState];

            for (let cob of coberturasStateData) {
                if (dictCoberturas[cob.numeroCobertura] !== undefined) {
                    cob.selected = true;
                    cob.sumaAsegurada = dictCoberturas[cob.numeroCobertura].sumaAsegurada;
                } else {
                    cob.selectedCobertura = false;
                    cob.selectedCobertura = dict[cob.numeroCobertura].sumaChica;
                }
            }
            setCoberturasState(coberturasStateData);

            for (let cob of values.coberturasAdicionales) {
                if (dictCoberturas[cob.numeroCobertura] !== undefined) {
                    cob.selectedCobertura = true;
                    cob.sumaAsegurada = dictCoberturas[cob.numeroCobertura].sumaAsegurada;
                } else {
                    cob.selectedCobertura = false;
                    cob.sumaAsegurada = dict[cob.numeroCobertura].sumaChica;
                }
            }
        } else {
            for (let cob of values.coberturasAdicionales)
                cob.selectedCobertura = false

            for (let cobertura of values.coberturasAdicionales)
                cobertura.sumaAsegurada = dict[cobertura.numeroCobertura].sumaChica;

            let coberturasStateData = [...coberturasState];

            for (let cob of coberturasStateData)
                cob.sumaAsegurada = dict[cob.numeroCobertura].sumaChica;

            setCoberturasState(coberturasStateData);
        }
        setDictCoberturasInfo(dict)
    }, []);

    if (!dictCoberturasInfo) return <Loading/>;
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <Field
                        name={afinidad.name}
                        label={afinidad.label}
                        component={FormikAutocomplete}
                        options={afinidades}
                        textFieldProps={{
                            label: afinidad.label,
                            required: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12} style={{marginTop: "8px"}}>
                    <InputField
                        name={fechaCotizacion.name}
                        label={fechaCotizacion.label}
                        type="date"
                        fullWidth
                        InputLabelProps={{shrink: true,}}
                        textTransform={'lowercase'}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Field
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        component={FormikAutocomplete}
                        options={localidades}
                        textFieldProps={{
                            label: codigosLocalidad.label,
                            required: true,
                        }}
                    />
                </Grid>

            </Grid>
            <div style={{display: "flex", flexDirection: "column", marginTop: "40px"}}>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 72px 16px 16px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                    <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                        {coberturasState.map((item, index) => (
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                minHeight: "48px",
                                maxHeight: "48px",
                                margin: "4px",
                            }}>
                                <div style={{
                                    width: "65%", display: "flex",
                                    flexDirection: "row", alignItems: "center"
                                }}>
                                    <div style={{width: "10%"}}>
                                        {item.numeroCobertura === '44' || item.numeroCobertura === '45' || item.numeroCobertura === '50' ?
                                            <Checkbox
                                                style={{color: "#bb0d66"}}
                                                disabled={true}
                                                checked={true}
                                            />
                                            :
                                            <Checkbox
                                                style={{color: "#bb0d66"}}
                                                checked={coberturasState[index].selected}
                                                value={coberturasState[index].sumaAsegurada}
                                                onChange={() => handleChecked(index)}
                                            />
                                        }
                                    </div>

                                    <div style={{
                                        width: "30%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center"
                                    }}>
                                        <Grid item xs={2} className={classes.centerContent}>
                                            {iconsDict[item.numeroCobertura]}
                                        </Grid>
                                    </div>

                                    <div style={{width: "60%"}}>
                                        <Typography className={classes.tableRowLabel}>
                                            {dictCoberturasInfo[item.numeroCobertura].descripcion}
                                        </Typography>
                                    </div>

                                </div>

                                {item.numeroCobertura === '44' || item.numeroCobertura === '45' || item.numeroCobertura === '50' ?
                                    <p style={{width: "2%"}}>&nbsp;&nbsp;</p>
                                    :
                                    item.selected
                                        ? <p style={{width: "1%",}}>$</p>
                                        : <p style={{width: "1%"}}>&nbsp;&nbsp;</p>
                                }

                                <div style={{width: "20%"}}>
                                    {item.numeroCobertura === '44' || item.numeroCobertura === '45' || item.numeroCobertura === '50' ?
                                        <p className={classes.noCost}>Sin costo</p>
                                        :
                                        item.selected && (
                                            <NumberField
                                                name={`coberturasAdicionales[${index}].${sumaAsegurada.name}`}
                                                errorText={`${sumaAsegurada.requiredErrorMsg}`}
                                                label={""}
                                                inputProps={{style: {textAlign: 'right'}}}
                                                onBlur={(e) => handleValueChange(e, index)}
                                            />
                                        )
                                    }
                                </div>

                                <div style={{width: "5%"}}>
                                    <PopOverDetails
                                        descripcion={dictCoberturasInfo[item.numeroCobertura].descripcionCompleta}
                                    />
                                </div>
                            </div>
                        ))}
                    </Grid>
                </Grid>
            </div>

            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
